<template>
    <div id="gotohome">
        <a href="#" onclick="javascript:window.history.back(-1);return false;">
            <!-- <img border="0" src="static/img/favicon.ico" width="32" height="32" alt="ロゴ"> -->
            <svg class="bi" width="32" height="32" fill="currentColor">
                <use :xlink:href="home_icon_path"/>
            </svg>
        </a>
    </div>
</template>

<script>
import config from '../config/config.js'
import path from 'path'

const home_icon_default_path = '/static/img/bootstrap-icons.svg#house-door-fill';
export default {
  name: 'Logo',
  computed: {
      home_icon_path() {
          return path.join(config.DOMAIN, config.PREFIX, home_icon_default_path);
      }
  }
}
</script>

<style scoped>
#gotohome {
    padding: 4px;
}
a {
    color: darkgray;
}
a:hover {
  color: gray;
}
</style>
